const localizers = {
  'loading.msg': () => `Läser in...`,
  'SASServer.genericError.msg': () => `Servern kan inte nås.`,
  'SASReport.genericError.msg': () => `Det går inte att läsa in den valda rapporten.`,
  'SASReportImage.genericError.msg': () => `Det gick inte att läsa in rapportbilden.`,
  'SASReportImage.imageNotSupported.msg': () => `Bilder stöds inte för den här rapportinnehållstypen.`,
}
export default localizers;
